import { Utils } from '@genial/utils';

export const getNoticeText = (date: Date): string => {
  return `Informações do dia ${Utils.Mask.DateFormat(date, 'dd/MM/yyyy')}.`;
};
